import { useState, useMemo } from 'react';

export const usePaperFilters = (papers) => {
  const [filters, setFilters] = useState({
    sortBy: 'relevance',
    yearFilter: '',
    minCitations: '',
    searchQuery: '',
    selectedFields: []
  });

  const filteredPapers = useMemo(() => {
    let filtered = [...papers];


    // Apply filters with null/undefined safety checks
    if (filters.yearFilter) {
      filtered = filtered.filter(paper => paper.year && paper.year >= parseInt(filters.yearFilter));
    }

    if (filters.minCitations) {
      filtered = filtered.filter(paper => paper.citationCount && paper.citationCount >= parseInt(filters.minCitations));
    }

    if (filters.selectedFields.length > 0) {
      filtered = filtered.filter(paper =>
        Array.isArray(paper.fieldsOfStudy) && paper.fieldsOfStudy.some(field => filters.selectedFields.includes(field))
      );
    }

    if (filters.searchQuery) {
      const query = filters.searchQuery.toLowerCase();
      filtered = filtered.filter(paper =>
        (typeof paper.title === 'string' && paper.title.toLowerCase().includes(query)) ||
        (typeof paper.abstract === 'string' && paper.abstract.toLowerCase().includes(query))
      );
    }

    // Sort papers
    return filtered.sort((a, b) => {
      switch (filters.sortBy) {
        case 'year':
          return b.year - a.year;
        case 'citations':
          return b.citationCount - a.citationCount;
        case 'relevance':
        default:
          return 0;
      }
    });
  }, [papers, filters]);

  return { filters, setFilters, filteredPapers };
}; 